import './LocationPermissionPrompt.css';

interface Props {
  error: string;
}

export function LocationPermissionPrompt({ error }: Props) {
  return (
    <div className="location-prompt">
      <div className="location-prompt-card">
        <div className="location-prompt-title">Location unavailable</div>
        <div className="location-prompt-detail">{error}</div>
        <div className="location-prompt-hint">
          Allow location access in your browser to center the map on your car.
        </div>
      </div>
    </div>
  );
}
